import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  root: {
    color: theme.palette.colors.gray,
    paddingTop: 20,
    margin: 0,
  },
  thumb: {
    width: 24,
    height: 24,
    marginTop: -8,
    marginLeft: -12,
    boxSizing: 'border-box',
    backgroundColor: theme.palette.colors.teal,
    '&:focus, &:hover, &$active': {
      boxShadow: 'none',
    },
  },
  hidden: {
    display: 'none',
  },
  active: {},
  track: {
    height: 8,
    borderRadius: 4,
  },
  mark: {
    top: -5,
    height: 8,
    width: 1,
    backgroundColor: theme.palette.colors.blueGray,
  },
  markLabel: {
    color: theme.palette.colors.blueGray,
    top: -25,
  },
  rail: {
    height: 8,
    borderRadius: 4,
  },
}));



// WEBPACK FOOTER //
// ./src/sharedComponents/Slider/useStyles.js